import { useQueryResponse } from '../../core/QueryResponseProvider'
import { AtendimentoColumns } from './columns/_columns'
import { AtendimentoPacienteList } from '../../core/_models'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { CustomTable, TableEmptyState } from '../../../../../components'
import { useMemo } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'

export const AtendimentosTable = () => {
  const { isLoading, isError, refetch, response } = useQueryResponse()
  const { t } = useT()

  const columns = useMemo(() => AtendimentoColumns(t), [t])

  return (
    <CustomTable<AtendimentoPacienteList>
      id='kt_table_atendimentos_pacientes'
      ariaLabel='Atendimentos'
      itemLabel={{ singular: 'atendimento', plural: 'atendimentos' }}
      data={response?.data || []}
      columns={columns}
      isLoading={isLoading}
      isError={isError}
      onRetry={refetch}
      emptyState={
        <TableEmptyState
          title='Nenhum atendimento encontrado'
          description='Os atendimentos solicitados aparecem aqui.'
        />
      }
      queryHooks={{ useQueryRequest, useQueryResponse }}
    />
  )
}
